module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'propertiesForm'
	],

	methods: {
		getResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				if(!this.model.activityYear){
					this.model.activityYear = ((this.getResourceRegisterContent('relation') || {}).activityYear || 0) * 1;
				}

				resourceFilters = resourceFilters || {};
				resourceFilters.minDate = this.model.activityYear + '-01-01';
				resourceFilters.maxDate = (this.model.activityYear + 1) + '-01-01';
			}
			return resourceFilters;
		}
	}
}
